import { createStore } from 'zustand';
import { StoreSettings } from '@/types/gearApi/StoreSettings';

export type StorefrontSettingsState = StoreSettings;

export const createStorefrontSettingsStore = (initState: StorefrontSettingsState) => {
	return createStore<StorefrontSettingsState>(() => ({
		...initState,
	}));
};
